import _ from "lodash";
import * as AT from "../vault/ActionTypes";
import React from "react";
import CopyTable from "../util/CopyTable";
import OpsUser from "../vault/OpsUser";
import TeacherModal from "../view/TeacherModal";
import Mixpanel from "../util/Mixpanel";
import withVaultDispatch from "../hoc/withVaultDispatch";
import URLMake from "../../../shared/URLMake";
import ImitateStudentLink from "../../office/ImitateStudentLink";
import * as styles from "./styles/InvalidUserForSchoolModal.css";

// TODO: Replace with proper type
type User = any;

export const InvalidUserForSchoolModal = withVaultDispatch(
	({user, dispatch}: {user: User; dispatch: (action: any) => void}) => {
		const isTeacher = OpsUser.hasTeacherRole(user);
		const displayName =
			_.get(user, "model.displayName") ??
			_.get(user, "model.username") ??
			_.get(user, "model.email");

		const handleStudentClick = (student: any) => {
			if (student.hasRegistered) {
				Mixpanel.track("Parent Login As Student", {
					studentId: student.id,
					studentUsername: student.username,
					method: "from-trainer",
				});
				// Dispatch the action through the vault system
				dispatch({
					type: AT.IMITATE_STUDENT_REQUEST,
					student,
				});
			} else {
				// TODO: Redirect to primary registration page
				redirectPage(student);
			}
		};

		const redirectPage = (student?: any) => {
			let pageState = URLMake.state.forEnroll();
			if (OpsUser.hasRole(user, "parent")) {
				pageState = URLMake.state.forParentStudentPrimaryRegistration(
					student?.id
				);
			}
			dispatch({
				type: AT.SET_PAGE,
				pageState,
			});
		};

		if (isTeacher) {
			return (
				<TeacherModal
					cannotClose
					heightAuto
					buttonTexts={["Go to Accounts"]}
					buttonClickHandlers={[redirectPage]}
				>
					You are signed in as {displayName}.<br />
					<br />
					{CopyTable.forDeactivatedTeacher()}
				</TeacherModal>
			);
		} else {
			const students = _.get(user, ["model", "students"], []);
			const activeStudents = students.filter(
				(student: any) => student.isActive || student.inActiveClasses
			);
			if (activeStudents.length === 0) {
				return (
					<TeacherModal
						cannotClose
						size="large"
						buttonTexts={["Go to Accounts"]}
						buttonClickHandlers={[redirectPage]}
					>
						<p>You are signed in as {displayName}.</p>
						<p>
							There are currently no active subscriptions on this account. To
							play BA Online, reactivate a subscription today.
						</p>
					</TeacherModal>
				);
			} else {
				return (
					<TeacherModal
						cannotClose
						heightAuto
						buttonTexts={["Go to Parent Pages"]}
						buttonClickHandlers={[redirectPage]}
					>
						<div>
							You are signed in as <b>{displayName}</b>.
						</div>
						<p>Continue as your student to start playing:</p>
						<div className={styles.studentList}>
							{activeStudents.map((student: any) => (
								<a key={student.id} className={styles.studentLink}>
									<ImitateStudentLink
										student={student}
										onClick={() => handleStudentClick(student)}
										avatarClassName={styles.studentAvatar}
									/>
								</a>
							))}
						</div>
					</TeacherModal>
				);
			}
		}
	}
);

export default InvalidUserForSchoolModal;
